<template>
  <div>
    <div
      class="font-size-14"
      :data-qa="`${dataQa}-name`">
      {{ item.name || '–' }}
    </div>
    <div
      class="font-size-12 pa-0 ma-0 opacity-8">
      <div
        v-if="item.departmentTitle"
        :data-qa="`${dataQa}-departmentTitle`">
        {{ item.departmentTitle || '–' }}
      </div>
      <div
        :data-qa="`${dataQa}-email`">
        {{ item.email || '–' }}
      </div>
      <div
        :data-qa="`${dataQa}-phone`">
        {{ item.telephone || item.phone || '–' }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'contactPerson',
  data() {
    return {}
  },
  methods: {},
  computed: {},
  components: {},
  created() {},
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    dataQa: {
      type: String,
      default: 'contact-person'
    }
  }

}
</script>
<style scoped lang="scss">
</style>
